import React from 'react';
import TextField from 'material-ui/TextField';
import { CardActions, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';

class TagForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      section: this.props.section || "monitoring",
      labelErrorText: null
    }
  }

  render() {
    let header = this.props.category ? "Update Tag" : "New Tag";
    return (
      <Dialog open={this.props.open} title={header}>
        <CardText>
          <TextField
            ref={(f) => this.labelField = f}
            hintText="Tag Label"
            defaultValue={this.props.label}
            errorText={this.state.labelErrorText}
          /><br />
          <SelectField
            disabled={!!this.props.id}
            floatingLabelText="Section"
            ref="section"
            value={this.state.section}
            onChange={this.handleSectionChange}
          >
            <MenuItem value="monitoring" primaryText="Data Collection" />
            <MenuItem value="assessment" primaryText="Assessment" />
            <MenuItem value="controlRules" primaryText="Management Measures" />
          </SelectField>
        </CardText>
        <CardActions style={{textAlign: "right"}}>
          {
            this.props.id && <FlatButton onClick={this.handleDelete} label="delete" />
          }
          <FlatButton onClick={this.handleCancel} label="cancel" />
          <RaisedButton onClick={this.handleSave} primary={true} label="Save" />
        </CardActions>
      </Dialog>
    )
  }

  componentDidUpdate = () => {
    setTimeout(() => {
      if (this.labelField) {
        this.labelField.focus();
      }
    }, 100);
  }

  handleSectionChange = (e, index, value) => {
    this.setState({section: value});
  }

  checkLabelText = () => {
    if (this.labelField.getValue().length > 1) {
      return true;
    } else {
      this.setState({labelErrorText: "Must provide a tag label"});
      return false;
    }
  }

  handleSave = () => {
    if (this.checkLabelText()) {
      if (this.props.onSave) {
        this.props.onSave({
          id: this.props.id,
          label: this.labelField.getValue(),
          section: this.state.section
        })
      }
    }
  }

  handleDelete = () => {
    if (global.confirm(`Are you sure you want to delete ${this.props.label}?`)) {
      this.props.onDelete(this.props.id);      
    }
  }

  handleCancel = () => {
    this.props.onRequestClose();
  }

}

export default TagForm;
